import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi";

const Frequentqes = () => {
  const faqs = [
    {
      question: "What Services does EAP Finance offer?",
      answer: (
        <div>
          At EAP Finance, we provide a comprehensive suite of financial services designed to help individuals and corporations achieve their financial goals. Our expertise includes:
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Strategic capital raising solutions</li>
            <li>Expert stock portfolio management</li>
            <li>Corporate finance advisory services</li>
            <li>Personalized wealth management strategies</li>
            <li>Alternative investment solutions tailored to your needs</li>
          </ul>
        </div>
      )
    },
    {
      question: "How Long Does Capital Raising Take?",
      answer: "The capital-raising timeline varies based on factors like funding type, business complexity, and market conditions. Typically, it can range from 3 to 6 business days. Our team is dedicated to streamlining the process while negotiating the most favorable terms for your benefit."
    },
    {
      question: "Is EAP Finance's Portfolio Management Right for Beginners?",
      answer: "Absolutely! Our portfolio management services cater to investors of all experience levels. For beginners, we provide personalized guidance to help you understand investment strategies, create a customized portfolio, and achieve long-term financial growth. Whether you're new to investing or looking to optimize your existing portfolio, we're here to support you every step of the way."
    },
    {
      question: "How Secure is My Payment Information with EAP Finance?",
      answer: "Rest assured, your payment information is protected with the highest level of security. We utilize advanced encryption and adhere to industry-standard security protocols to safeguard your data, ensuring secure and reliable transactions."
    },
    {
      question: "How Often Will I Receive Updates on My Portfolio?",
      answer: "At EAP Finance, transparency is our priority. You'll receive regular updates on your portfolio's performance, and you'll have direct access to our team for questions, insights, or guidance. Plus, you can track your portfolio's status anytime through our secure online platform, giving you complete visibility and control."
    },
    {
      question: "What Are Alternative Investments?",
      answer: (
        <div>
          Alternative investments refer to assets beyond traditional stocks and bonds, including private equity, venture capital, real estate, commodities, and more. By incorporating these assets into your portfolio, you can potentially:
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Diversify your investments to reduce reliance on any one asset class</li>
            <li>Mitigate risk and increase resilience during market fluctuations</li>
            <li>Enhance returns and achieve more consistent growth</li>
          </ul>
          <p className="mt-2">Alternative investments can be a valuable addition to your portfolio, especially in times of market volatility.</p>
        </div>
      )
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-6xl mx-2 lg:mx-auto my-8 p-4 sm:p-8 bg-gray-50/80 text-[#000] rounded-xl shadow-lg">
      <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
        Frequently Asked Questions
      </h2>
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-600 pb-4">
            <h3
              className="text-sm sm:text-md md:text-md lg:text-lg font-semibold cursor-pointer flex justify-between items-center gap-4"
              onClick={() => toggleFAQ(index)}
            >
              <span className="flex-1">{faq.question}</span>
              <span
                className={`text-[#fff] bg-[#000] rounded-full w-6 h-6 flex items-center justify-center transform transition-transform duration-300 ${
                  activeIndex === index ? "rotate-180" : ""
                }`}
              >
                <HiChevronDown className="text-xl" />
              </span>
            </h3>
            {activeIndex === index && (
              <div className="mt-4 text-sm sm:text-sm text-gray-600">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Frequentqes;